module.exports = __webpack_public_path__ + "3f8d5c792bb0c8b00fcaeb876111ee2f.png";